<script lang="ts">
    import {afterUpdate} from "svelte";
    import Sortable from "../../utilities/sortable";
    import {blur} from "svelte/transition";

    // import type {TacticalPlanRuleResponseType} from "./TacticalPlanRuleApi";
    import type {VehicleResponseType} from "../Vehicles/types";
    import TacticalPlanRuleOne from "./TacticalPlanRuleOne.svelte";
    import {reorderRules} from "../../utilities/TacticalPlans";
    import type {TacticalPlanRule} from "./TacticalPlanRule";
    import {tacticalPlanRuleCurrent, tacticalPlanStore} from "../../../stores/store";
    import {TacticalPlanRuleApi} from "./TacticalPlanRuleApi";
    import {get} from "svelte/store";
    import {api} from "../../../stores/api";
    import {_} from "svelte-i18n";
    import type {TacticalPlanValidator} from "./TacticalPlanValidator";
    import type {SimpleZoneType} from "../Zones/ZoneApi";
    import type {ValidatorReport} from "./ValidatorReport";

    export let tacticalPlanRules: TacticalPlanRule[] = [];
    export let vehicles: VehicleResponseType[]  = [];
    export let addEmptyRuleBefore: (tacticalPlanRules: TacticalPlanRule[], rule: TacticalPlanRule, deepcopy: boolean, currentPriority:number|null) => Promise<TacticalPlanRule[]>;
    export let saveTacticalPlanWithRules: (tacticalPlanRules: TacticalPlanRule[]) => void;
    export let tacticalPlanValidatorReport: ValidatorReport;
    export let simpleZones: SimpleZoneType[] | null = null;
    export let alreadyUsedVehicles: number[] = [];

    let expandedIndex: number = -1;
    let sortable: any = null;
    let listElement: HTMLDivElement;
    let zoneVisibility: Record<number, boolean> = {};

    function onRemove(rule: TacticalPlanRule) {
        $tacticalPlanStore.triggerStartSaveThisRuleByInnerId = '__remove__';
        let ruleId = rule.getId();
        if (ruleId!==null) {
            TacticalPlanRuleApi.removeOne(get(api), ruleId).then(() => {
                tacticalPlanRules = tacticalPlanRules.filter(r => r.getInnerId() !== rule.getInnerId());
                $tacticalPlanStore.triggerStartSaveThisRuleByInnerId = '';
                // simpleZones = null;
            });
        }
    }

    async function addRuleBeforeThisRule(rule: TacticalPlanRule, deepcopy: boolean, currentPriority: number|null = null): Promise<TacticalPlanRule|undefined> {
        let tp_rules = await addEmptyRuleBefore(tacticalPlanRules, rule, deepcopy, currentPriority);
        console.log('addEmptyRuleBeforeThisRule, tp_rules', tp_rules.map(rule => rule.getId()));
        tacticalPlanRules = tp_rules;
        simpleZones = null;
        return tp_rules.find(r => r.getInnerId()===rule.getInnerId());
    }

    function onZoneVisibleExclusive(ruleId: number) {
        zoneVisibility[ruleId] = true;
        for (let i in zoneVisibility) {
            if (parseInt(i) !== ruleId) {
                zoneVisibility[i] = false;
            }
        }
    }

    afterUpdate( () => {
        sortable = Sortable.create(listElement, {
            // filter: ".no-drag",
            handle: ".sortable-item-handle",
            animation: 150,
            onStart: function(evt: Event) {
                console.log('onStart', evt);
                $tacticalPlanRuleCurrent = null;
                $tacticalPlanStore.triggerZonesSave = true;
            },
            onEnd: function (evt: Event) {
                // const itemEl = evt.item;  // dragged HTMLElement
                let order = sortable.toArray("data-id");
                console.log('order, onEnd, toArray', order)
                expandedIndex = order.map((id: string) => parseInt(id.split('_')[0])).indexOf(expandedIndex);
                tacticalPlanRules = reorderRules(order.map((id: string) => parseInt(id.split('_')[0])), tacticalPlanRules);
                console.log('tacticalPlanRules, onEnd', tacticalPlanRules.map(rule => rule.getId()))
                saveTacticalPlanWithRules(tacticalPlanRules);
            }
        });
    })

    $: {
        if (tacticalPlanRules.length===1) {
            expandedIndex = 0;
        }
    }

    $: {
        tacticalPlanRules.sort((a, b) => b.getRule().priority - a.getRule().priority);
        tacticalPlanRules.forEach((rule) => {
            if (rule.getId() !== null && !(rule.getId() in zoneVisibility)) {
                zoneVisibility[rule.getId()] = true;
            }
        })
        // console.log('sort tacticalPlanRules by priority', tacticalPlanRules.map(rule => rule.getId()) );
    }

</script>


<div class="tactical-plan-rule-list">
    <div  bind:this={listElement}>
    {#each tacticalPlanRules as rule, index (rule.getInnerId()) }
        {#if !rule.isAlwaysLast()}
            <div in:blur|global data-id={index + '_' + rule.getRule().priority + '_' + rule.getId()} data-rule-priority={rule.getRule().priority} >
                <TacticalPlanRuleOne bind:rule {vehicles} bind:alreadyUsedVehicles {index} {onRemove} {addRuleBeforeThisRule} readOnly={$tacticalPlanRuleCurrent!==rule.getInnerId()} {tacticalPlanValidatorReport} bind:simpleZones bind:zonesVisible={zoneVisibility[rule.getId()]} onZoneVisibleExclusive={onZoneVisibleExclusive}/>
            </div>
        {/if}
    {/each}
    </div>

    {#each tacticalPlanRules as rule, index (rule.getInnerId()) }
        {#if rule.isAlwaysLast()}
            <div in:blur|global data-id={index + '_' + rule.getRule().priority + '_' + rule.getId()} data-rule-priority={rule.getRule().priority} >
                <TacticalPlanRuleOne bind:rule {vehicles} bind:alreadyUsedVehicles {index} {onRemove} {addRuleBeforeThisRule} readOnly={$tacticalPlanRuleCurrent!==rule.getInnerId()} {tacticalPlanValidatorReport} bind:simpleZones />
            </div>
        {/if}
    {/each}
</div>


<style>
    .tactical-plan-rule-list {
        display: flex;
        flex-direction: column;
        margin-top: 8px;
        margin-bottom: 30px;
    }
</style>